export const FeatureName = 'federations';
